const mediaItems = [
  {
    id: 1,
    title: '2026夏季新番导览：不可错过的日漫推荐',
    desc: '新一季日漫全面开播，从异世界到恋爱喜剧，编辑团队为你精挑细选本季最值得追的十部作品。',
    duration: '12:35',
    views: '8.6万',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20illustration%20of%20a%20summer%20Japanese%20manga%20scene%20with%20bright%20sunlight%2C%20blue%20sky%2C%20and%20colorful%20manga%20characters%20in%20casual%20summer%20outfits%2C%20warm%20and%20energetic%20atmosphere%2C%20clean%20editorial%20composition%2C%20soft%20lighting%2C%20no%20text&width=800&height=450&seq=media-card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '编辑深度解析：《电锯人》第二部的最新走向',
    desc: '藤本树的叙事再次颠覆想象，我们聊一聊三鹰朝与电次的命运纠葛，以及第二部隐藏的伏笔细节。',
    duration: '18:22',
    views: '6.3万',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20anime%20illustration%20with%20dark%20urban%20atmosphere%2C%20neon%20accents%2C%20manga%20panel%20composition%2C%20intense%20mood%2C%20Japanese%20comic%20style%2C%20warm%20amber%20highlights%20on%20dark%20background%2C%20cinematic%20lighting%2C%20no%20text&width=800&height=450&seq=media-card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '经典日漫回顾：为什么《钢之炼金术师》永不过时',
    desc: '等价交换的哲学、丰满的人物弧光、紧凑的叙事节奏——重温这部影响了无数读者的日漫经典。',
    duration: '15:48',
    views: '5.1万',
    image: 'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20anime%20illustration%20with%20golden%20and%20sepia%20tones%2C%20steampunk%20aesthetic%2C%20alchemy%20themed%20composition%2C%20soft%20glowing%20transmutation%20circle%20motif%2C%20elegant%20Japanese%20manga%20art%20style%2C%20vintage%20editorial%20feel%2C%20no%20text&width=800&height=450&seq=media-card-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            视频推荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            精彩推荐
          </h2>
          <p className="text-foreground-500 text-sm mt-2">编辑团队精选日漫解读与导览</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <article key={item.id} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                <div className="absolute bottom-3 right-3 bg-black/70 backdrop-blur-sm text-white text-xs px-2 py-1 rounded-md">
                  <i className="ri-play-fill mr-1"></i>{item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-all cursor-pointer">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {item.desc}
                </p>
                <span className="text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>{item.views} 次观看
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}